import React from "react";
import s from "./Grid.module.scss";

const Grid = ({ gridId, collapse, children, style }) => {
  return (
    <div
      id={gridId}
      className={[s.col, collapse ? s.collapse : ""].join(" ")}
      style={style}
    >
      {children}
    </div>
  );
};

export default React.memo(Grid);
